// extracted by mini-css-extract-plugin
export default {"exerciseWrapper":"Exercise_exerciseWrapper__zQqlE","textWrapper":"Exercise_textWrapper__elUwz"};